import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress';
import ProfileDetail from './ProfileDetail'
import { fetchProfile } from '../actions/index'

const styles = theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  }
})

class Profile extends Component {
    constructor(props) {
      super(props)
    }
  
    componentDidMount() {
      const { match, dispatch } = this.props
      const UID =  match.params.profileUrl.includes('-') ? match.params.profileUrl.substring(match.params.profileUrl.lastIndexOf("-")+1) : match.params.profileUrl;
      dispatch(fetchProfile(UID))
    }
  
    render() {
      const { classes, match, isFetchingProfile, profile } = this.props
      
      return (
        <div className={classes.root}>
          {/* <h1>Profile</h1>
          <p>{`match.url: ${match.url}`}</p>
          <p>{`match.path: ${match.path}`}</p>
          <p>{`match.params.UID: ${match.params.UID}`}</p> */}
          {isFetchingProfile && <CircularProgress />}
          {!isFetchingProfile && <ProfileDetail profile={profile}/>}
        </div>
      )
    }
}

export default withStyles(styles)(Profile)


// WEBPACK FOOTER //
// ./src/components/Profile.js